module.exports = __webpack_public_path__ + "img/192.2d5cb3c0.jpg";